import {AbstractCustomPointRequest} from './abstracts/abstract-custom-point-request';

export class TextPointRequest extends AbstractCustomPointRequest {

  public constructor() {
    super();
  }
}
